import {
  Breadcrumb,
  BreadcrumbEllipsis,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@loot-os/ui/components/breadcrumb";
import { Link } from "@tanstack/react-router";
import { Fragment } from "react";

import type { BoxesBreadcrumbContent } from "../../pages/boxes/content/heading.js";

/** The design's breadcrumb: the pages above collapsed into an ellipsis, then this page. */
export function ClassicBoxesBreadcrumb({ trail, current }: BoxesBreadcrumbContent) {
  return (
    <Breadcrumb>
      <BreadcrumbList className="sm:gap-1.5">
        {trail.map((link) => (
          <Fragment key={link.to}>
            <BreadcrumbItem>
              <BreadcrumbLink
                render={<Link to={link.to} />}
                aria-label={link.label}
                title={link.label}
              >
                <BreadcrumbEllipsis />
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="[&>svg]:size-4" />
          </Fragment>
        ))}
        <BreadcrumbItem>
          <BreadcrumbPage>{current}</BreadcrumbPage>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  );
}
